/* unplugin-vue-components disabled */import script from "./Workspace.vue?vue&type=script&setup=true&lang=js"
export * from "./Workspace.vue?vue&type=script&setup=true&lang=js"

import "./Workspace.vue?vue&type=style&index=0&id=1aa1033f&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户湖南中医药大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa1033f"]])

export default __exports__